module.exports = __webpack_public_path__ + "static/img/winner_top.5db41d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winner_top.png
// module id = RWa3
// module chunks = 1